export default __webpack_public_path__ + "media/zurb/img/development-process/code_delivery-8ef3e1a7d92eb355cd26e81d387a1fc5.png";